<template>
    <div class="specialMeansMgt">
        <div class="filters">
            <div class="add flexstart">
                <el-button type="primary" @click="handleImport">上传资料</el-button>
            </div>
            <div class="search">
                <el-input v-model="param.keyname" placeholder="请输入关键字" class="condition" clearable></el-input>
                <el-button type="primary" plain @click="handleQuery">搜索</el-button>
            </div>
        </div>
        <div class="result-list btn-operate-list">
            <el-table :data="tableData" style="width: 100%" ref="multipleTable">
                <el-table-column prop="docname" label="资料名称" min-width="120px" class-name="title">
                    <template slot-scope="scope"><div class="text-ellipses"><div class="text">{{scope.row.docname}}</div></div></template>
                </el-table-column>
                <el-table-column prop="doctype" label="资料格式" class-name="tc" label-class-name="tc">
                    <template slot-scope="scope"><span>{{scope.row.doctype}}</span></template>
                </el-table-column>
                <el-table-column prop="filesize" label="资料大小" class-name="tc" label-class-name="tc"></el-table-column>
                <el-table-column prop="downloadcount" label="下载次数" class-name="tc" label-class-name="tc"></el-table-column>
                <el-table-column prop="datetime" label="上传时间" class-name="tc" label-class-name="tc"></el-table-column>
                <el-table-column label="操作" min-width="80px" label-class-name="tr">
                    <template slot-scope="scope">
                        <div class="tr">
                                <span class="separator-btn">
                                    <el-button @click.stop="handleDel(scope.row)" type="text" size="small">删除</el-button>
                                </span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background @current-change="_getList" :current-page.sync="page.page" :page-size="page.pageSize"
                           :pager-count="11" layout="prev, pager, next" :total="total">
            </el-pagination>
        </div>
        <uploadFileDialog ref="uploadFileDialog" @submitFile="_submitFile"></uploadFileDialog>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {getQuestionbanktopicdocumentinfo, deleteQuestionbanktopicdocumentinfo, uploadQuestionbanktopicdocumentinfo} from 'api/questionApi'
import UploadFileDialog from 'views/cms/special/components/uploadFileDialog.vue'
import {_filter, special} from 'api/enumCode'

export default {
    name: 'specialMeansMgt',
    data() {
        return {
            tableData: [],
            page: {
                page: 1,
                pageSize: 10,
                pageCount: 0
            },
            total: 0,
            param: {
                customername: '',
                examcode: this.$route.query.examcode ? this.$route.query.examcode : ''
            },
            init: false
        }
    },
    mounted() {
    },
    methods: {
        initData() {
            if (!this.init) this._getList()
        },
        handleQuery() {
            this.page.page = 1
            this._getList()
        },
        handleImport() {
            this.$refs.uploadFileDialog.openDialog()
        },
        _submitFile(item) {
            let file = {
                docname: item.filename ? item.filename : item.file.fname,
                examcode: this.param.examcode,
                filekeyid: item.file.key,
                filekeyurl: item.file.furl,
                filelength: item.file.fsize,
                orgfilename: item.file.fname,
            }
            this._importFile(file)
        },
        handleDel(row) {
            this.$confirm('确认删除', '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            }).then(() => {
                this._del(row.innerid)
            })
        },
        _importFile(file) {
            this.setLoading(true)
            uploadQuestionbanktopicdocumentinfo({
                data: file,
                success: () => {
                    this.$message.success('上传成功')
                    this.setLoading(false)
                    this._getList()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _del(param) {
            this.setLoading(true)
            deleteQuestionbanktopicdocumentinfo({
                data: {innerid: param},
                success: () => {
                    this.$message.success('删除成功')
                    this.setLoading(false)
                    this._getList()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getList() {
            this.setLoading(true)
            getQuestionbanktopicdocumentinfo({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.tableData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                    this.init = true
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions(['setLoading'])
    },
    filters: {
        doctypename(val) {
            return _filter(val, special.doctype)
        }
    },
    watch: {},
    computed: {},
    components: {
        UploadFileDialog
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .specialMeansMgt {
    }
</style>
